import { useEffect, useRef } from 'react';

const PERSISTED_ON_SCREEN_TIMEOUT = 100;

export const usePersistedOnScreen = (onPersistedOnScreen: (() => void) | undefined) => {
  const timeoutRef = useRef(0);

  const onPersistedOnScreenRef = useRef(onPersistedOnScreen);
  onPersistedOnScreenRef.current = onPersistedOnScreen;

  useEffect(() => {
    if (!onPersistedOnScreenRef.current) {
      return;
    }

    timeoutRef.current = window.setTimeout(() => {
      onPersistedOnScreenRef.current?.();
    }, PERSISTED_ON_SCREEN_TIMEOUT);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
};
